const ACTION_TYPE = {
    // auth
    AUTH_LOGOUT: '@auth/LOGOUT',
    AUTH_SUCCESS: '@auth/SUCCESS',
    AUTH_FAILED: '@auth/FAILED',
    AUTH_USERINFO: '@auth/GET_USERINFO',
    AUTH_USERINFO_FAILED: '@auth/GET_USERINFO_FAILED',

    // search device action
    SEARCH_PARAM_UPDATE: '@search/SEARCH_DEVICE_PRM_UPDATE',
    SEARCH_DEVICES_REQ: '@search/SEARCH_DEVICE_REQ',
    SEARCH_DEVICES: '@search/SEARCH_DEVICE',
    SEARCH_DEVICES_SUC: '@search/SEARCH_DEVICE_SUC',
    SEARCH_DEVICES_FAILED: '@search/SEARCH_DEVICE_FAILED',

    // customization
    SET_MENU: '@customization/SET_MENU',
    MENU_TOGGLE: '@customization/MENU_TOGGLE',
    MENU_OPEN: '@customization/MENU_OPEN',
    SET_FONT_FAMILY: '@customization/SET_FONT_FAMILY',
    SET_BORDER_RADIUS: '@customization/SET_BORDER_RADIUS',

    // settings
    INIT_SETTINGS: '@settings/INIT_SETTINGS',
    UPDATE_SETTINGS: '@settings/UPDATE_SETTINGS',
    LOAD_SETTINGS: '@settings/LOAD_SETTINGS',
    LOAD_SETTINGS_FAILED: '@settings/LOAD_SETTINGS',

    // management
    LOADING_MANAGEMENT_DTL: '@management/LOADING_MANAGEMENT_DTL',
    SAVE_MANAGEMENT_DTL: '@management/SAVE_MANAGEMENT_DTL',
    UPDATE_MANAGEMENT_DTL: '@settings/UPDATE_MANAGEMENT_DTL',
    SET_VIEWS_LIST: '@management/SET_VIEWS_LIST',
    SET_GROUPS: '@management/SET_GROUPS',
    SET_DEVICE_TYPES: '@management/SET_DEVICE_TYPES',
    SET_POLICIES: '@management/SET_POLICIES',
    SET_LICENSES: '@management/SET_LICENSES',
    SET_LABELS: '@management/SET_LABELS',

    // api failed
    API_RES_FAILED: '@api/API_RES_FAILED'
};

export default ACTION_TYPE;
